<div style="line-height: 28px;text-align: center;">
  <div class="center" style="display: inline-block;text-align: center;">
    <span class="data">{{data}}</span>
    <button mat-raised-button class="primary-800 medium ml-20" [dpBusy]="isBusy" (click)="resendEmail()">Resend Email</button>
  </div>
  <a class="remindMe" (click)="closeMe()">Remind me later</a>
</div>